import {
  WalletsTransactionsClient,
  Currency,
  TransactionHistory,
} from "@nestcoinco/hyper-api-gateway-api-client";

import apiConfig from "../config/api-config";
import { axiosInstance } from "../config/axios-instance";

interface HandleGetMyTransactionHistoryParams {
  page?: number;
  limit?: number;
  currencies?: Currency[];
}

const walletsTransactionsClient = new WalletsTransactionsClient(
  apiConfig,
  undefined,
  axiosInstance
);

const DEFAULT_CURRENCIES = [Currency.GEM, Currency.HPR];

const handleGetMyTransactionHistory = async (
  params?: HandleGetMyTransactionHistoryParams
): Promise<TransactionHistory[] | undefined> => {
  const { page, limit, currencies = DEFAULT_CURRENCIES } = params || {};
  try {
    const transactionHistory = (
      await walletsTransactionsClient.getMyTransactionHistory(
        page,
        limit,
        currencies
      )
    ).data;
    return transactionHistory.records;
  } catch {
    return;
  }
};

const handleGetMyTransactionDetails = async (
  transactionId: string
): Promise<TransactionHistory | undefined> => {
  try {
    const transactionHistory = (
      await walletsTransactionsClient.getMyTransactionDetail(transactionId)
    ).data;
    return transactionHistory;
  } catch {
    return;
  }
};

export { handleGetMyTransactionHistory, handleGetMyTransactionDetails };
